<template>
  <div class="intervention-action">
    <el-select
      v-close-on-zoom
      :value="state.action.location"
      placeholder="any location"
      :multiple="false"
      class="location-select"
      :disabled="readonly"
      @input="(locationKey) => selectLocation(locationKey)"
    >
      <el-option
        label="Any location"
        :value="null"
      />
      <el-option
        v-for="location in availableLocations"
        :key="location.key"
        :label="location.label.en"
        :value="location.key"
      />
    </el-select>
    <el-select
      v-close-on-zoom
      :value="state.action.id"
      placeholder="Select intervention"
      :disabled="readonly"
      class="intervention-select"
      @input="(interventionKey) => selectIntervention(interventionKey)"
    >
      <el-option
        v-for="intervention in availableInterventions"
        :key="intervention.key"
        :label="intervention.label.en"
        :value="intervention.key"
      />
    </el-select>
  </div>
</template>

<script>
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';

import { interventions } from '~lib/common/config/interventions';

export default {
  name: 'intervention-action',
  components: {},
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        action: {
          id: null,
          location: null,
        },
      },
    };
  },
  computed: {
    availableLocations() {
      const { caseConf } = this.emitter;
      const locations = this.states.find(
        (s) => s.id === 'physicalAssessmentLocations'
      ).possibleValues;
      const enabledInterventionLocationKeys = uniq(
        flatten(
          (caseConf.availableInterventions || []).map(
            (caseIntervention) => {
              const intervention = interventions.find(
                (intv) => intv.key === caseIntervention.key
              );
              return intervention.availableLocations;
            }
          )
        )
      );
      return enabledInterventionLocationKeys.map((locationKey) =>
        locations.find((location) => location.key === locationKey)
      ).filter(location => !!location);
    },
    availableInterventions() {
      const intvs = (interventions || []).filter((intervention) => {
        const caseIntervention = (
          this.emitter.caseConf.availableInterventions || []
        ).find((caseIntervention) => caseIntervention.key === intervention.key);
        if (!caseIntervention) {
          return false;
        }
        if (!this.state.action.location) {
          return true;
        }
        return intervention.availableLocations.includes(this.state.action.location);
      });
      return uniqBy(
        intvs.reduce((previous, current) => {
          // Expand interventions that map to multiple ones
          if (current.interventionTypeMapping) {
            return previous.concat(current.interventionTypeMapping);
          } else {
            return previous.concat(current);
          }
        }, []),
        'key'
      );
    },
  },
  created() {
    this.state.action = {
      ...this.state.action,
      ...(this.getData(this.ikey) || {}),
    };
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    selectLocation(locationId) {
      this.state.action.location = locationId;
      if (
        !this.availableInterventions.find(
          (intervention) => intervention.key === this.state.action.id
        )
      ) {
        this.state.action.id = null;
      }
      this.update();
    },
    selectIntervention(interventionKey) {
      this.state.action.id = interventionKey;
      this.update();
    },
    moulageAtLocation(location) {
      const { caseConf } = this.emitter;
      if (caseConf.moulages && caseConf.moulages[location]) {
        return caseConf.moulages[location];
      } else if (
        caseConf.structuralMoulages &&
        caseConf.structuralMoulages[location]
      ) {
        return caseConf.structuralMoulages[location];
      }
    },
    update() {
      this.putData(this.ikey, {
        ...this.state.action,
        type: 'INTERVENTION',
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.intervention-action {
  display: flex;
  flex-direction: column;
}
.intervention-select {
  margin-top: 10px;
}
</style>
